export default __webpack_public_path__ + "static/media/Cart-empty.ed20385d.svg";